import { createContext } from 'react';

import { ApplicationType } from '../types';

export interface ApplicationTypeContextType {
  applicationType: ApplicationType | null;
  dispatch: (applicationType: ApplicationType | null) => void;
}

export const ApplicationTypeContext = createContext<ApplicationTypeContextType>(
  {
    applicationType: null,
    dispatch: (empty) => empty,
  },
);
